export default __webpack_public_path__ + "static/media/arrowForwardHelpHighlight.178037c3.png";